import {
  Component,
  ChangeDetectionStrategy,
  Input,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { UntilDestroy } from '@ngneat/until-destroy';

import { SearchableSelectComponent } from '..';
import { StaticMessage } from '@shared/enums';

@UntilDestroy()
@Component({
  selector: 'app-searchable-select-form-control',
  templateUrl: './searchable-select-form-control.component.html',
  styleUrls: ['./searchable-select-form-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchableSelectFormControlComponent),
      multi: true,
    },
  ],
})
export class SearchableSelectFormControlComponent
  extends SearchableSelectComponent
  implements ControlValueAccessor
{
  //#region Inputs

  @Input() shouldDisplayLabel = false;
  @Input() label: string;
  @Input() localizationLabel: string;
  @Input() errorMessage: string;
  @Input() hintMessage: string;
  @Input() isRequired = true;
  @Input() hasInitialFocusDisabled = false;
  @Input() controlName: string;

  //#endregion

  StaticMessage = StaticMessage;

  //#region ControlValueAccessor methods

  writeValue(value: any): void {
    this.selectControl.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  registerOnTouched(_fn: any): void {}

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (isDisabled) {
      this.selectControl.disable({ emitEvent: false });
    } else {
      this.selectControl.enable({ emitEvent: false });
    }
  }

  //#endregion

  onSelectionChanged(event: MatSelectChange): void {
    this.propagateChange(event.value);
    super.onSelectionChanged(event);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private propagateChange = (_: any) => {};
}
